import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './product-filter-dropdown.component.scss';
import * as $ from 'jquery';
var ProductFilterDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(ProductFilterDropdown, _super);
    function ProductFilterDropdown(element) {
        var _this = _super.call(this, element) || this;
        _this.currentFilter = "";
        return _this;
    }
    ProductFilterDropdown.prototype.init = function () {
        var _this = this;
        var parseData = jsonData;
        this.filterJson = parseData.filters;
        this.productJson = parseData.products;
        this.depositInput = $('.product-filter-dropdown__deposit');
        this.filterItem = $('.product-filter-dropdown__item');
        this.slideRunner = $('.product-filter-dropdown__slide-runner');
        this.dropdown = $('.product-filter-dropdown__dropdown');
        $(document).ready(function () {
            _this.currentFilter = _this.filterItem.first().data('filter');
            _this.moveSlideRunner(_this.filterItem.first());
        });
    };
    ProductFilterDropdown.prototype.bindEvents = function () {
        var _this = this;
        this.dropdown.click(function (e) {
            $('.product-filter-dropdown__wrapper').toggleClass('product-filter-dropdown__wrapper--open');
        });
        this.depositInput.keyup(function (e) {
            if ((_this.depositInput.val() == '') || (_this.depositInput.val().toString().length > 1)) {
                _this.filterProducts(_this.currentFilter);
            }
        });
        $(document).on('click', '.product-filter-dropdown__item', function (e) {
            var filter = $(e.currentTarget);
            _this.currentFilter = filter.data('filter');
            _this.moveSlideRunner(filter);
            $('.product-filter-dropdown__dropdown-value-text').text(_this.currentFilter);
            $('.product-filter-dropdown__wrapper').removeClass('product-filter-dropdown__wrapper--open');
        });
        window.addEventListener('resize', this.debounce(function () {
            var currentFilterItem = $(".product-filter-dropdown__item[data-filter='" + _this.currentFilter + "']");
            _this.moveSlideRunner(currentFilterItem);
        }, 250, false));
        $(document).on('click', '.product-filter-dropdown__item', function (e) {
            var filter = $(e.currentTarget).data('filter');
            _this.filterProducts(filter);
        });
    };
    ProductFilterDropdown.prototype.filterProducts = function (tag) {
        var _deposit = this.depositInput.val();
        $('.product-card').addClass("product-card--hide");
        var filtered;
        filtered = this.productJson.filter(function (prod) {
            var _tmpPrice = prod.pricing[0].title.replace(/\s/g, '');
            var _price = parseFloat(_tmpPrice);
            if (_deposit != '') {
                return ((prod.tags.indexOf(tag) == -1) || (_price > _deposit));
            }
            else {
                return (prod.tags.indexOf(tag) == -1);
            }
        });
        setTimeout(function () {
            $('.product-card[data-id]').removeClass("product-card--hide").removeClass('product-card--filtered');
            if (filtered.length > 0) {
                filtered.forEach(function (el) {
                    $('.product-card[data-id="' + el.id + '"]').addClass("product-card--hide").addClass("product-card--filtered");
                });
            }
        }, 200);
    };
    ProductFilterDropdown.prototype.moveSlideRunner = function (filter) {
        var filterPositionLeft = filter.position().left;
        var filterWidth = filter.width();
        this.slideRunner
            .width(0)
            .css('left', filterPositionLeft + 35 + "px")
            .show()
            .delay(350)
            .width(filterWidth);
    };
    ProductFilterDropdown.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    return ProductFilterDropdown;
}(Base));
export { ProductFilterDropdown };



//////////////////
// WEBPACK FOOTER
// ./components/product-filter-dropdown/product-filter-dropdown.component.ts
// module id = 446
// module chunks = 0